export default {
  task: 'Task',
  number: 'Data ID',
  submitter: 'submitter',
  // submitter: 'Submit person',
  reviewer: 'Reviewer',
  apprStatus: 'Status for reviewing',
  passAll: 'Pass all',
  refuseAll: 'Reject all',
  reviewAll: 'All pending review',
  reviewPending: 'Pending review',
  passOne: 'Passed at the first time',
  passTwo: 'Passed at the second time',
  refuseOne: 'Rejected at the first time',
  refuseTwo: 'Rejected at the second time',
  reviewOne: 'First pending review',
  reviewTwo: 'Second pending review',
  reviewFour: 'Fourth pending review',
  exportStatus: 'Export status',
  notExported: 'Not exported',
  exported: 'Exported',
  to: 'to',
  start: 'Start time',
  end: 'End time',
  formStr1: 'Quality inspector',
  formStr2: 'Settlement status',
  formStr3: 'All',
  formStr4: 'Unsettled',
  formStr5: 'Settled',
  formStr6: 'Clear filter',
  inquire: 'Search',
  created: 'Created',
  updated: 'Updated',
  date: 'Date',
  gain: 'Earn points',
  operating: 'Operating',
  review: 'Review',
  reviewQuick: 'Review',
  view: 'View',
  revise: 'Modify',
  reviewOpinion: 'Review opinion',
  determine: 'Comfirm',
  nodata: 'No data',
  week: 'Last week',
  oneMonth: 'Last month',
  threeMonth: 'Last three months',
  the: '',
  passFrequency: ' pass',
  reviewFrequency: ' review',
  refuseFrequency: ' reject',
  exporting: 'Exporting',
  recycling: 'Recycling',
  recycled: 'Recycled',
  deal: 'Batching',
  unknown: 'Unknown',
  appealing: 'Appealing',
  transferred: 'Being transferred',
  taskStatus1: 'All',
  taskStatus2: 'Submitted and Modifiable',
  taskStatus3: 'Being reviewed',
  taskStatus4: 'Passed',
  taskStatus5: 'Refused and Modifiable',
  taskStatus6: 'Appealed',
  taskStatus7: 'Recycled',
  taskStatus8: 'Accepted',
  taskStatus9: 'Refuse',
  taskStatus10: 'Observation',
  taskStatus11: 'Is being applealed',
  taskStatus12: '1/2 Pass',
  taskStatus0: 'Task status',
  checkTimes: 'Quality inspection times',
  projectID: 'Project ID',
  reviewsQuick01: 'Exit quality inspection',
  reviewsQuick02: 'Exiting the quality inspection page, do you want to continue?',
  reviewsQuick03: 'Tips',
  reviewsQuick04: 'determine',
  // L新增
  taskID: 'task ID',
  teamID: 'team ID',
  assessor: 'assessor',
  time: 'time',
  auditNumber: 'Audit number',
  reSet: 'reset',
  passTheAudit: 'Pass The Audit',
  submittedForModification: 'Submitted For Modification',
  hasRecycled: 'Has Recycled',
  startTime: 'start Time',
  endTime: 'end Time',
  reviewProgress: 'review Progress',
  submissionTime: 'submission Time',
  auditTime: 'audit Time',
  oneReview: 'First floor pending',
  twoReview: 'Second floor pending',
  threeReview: 'Third floor pending',
  acceptor: 'acceptor',
  pendingAcceptance: 'Pending acceptance'
}



// WEBPACK FOOTER //
// ./src/lang/en/taskreviews.js